module.exports = __webpack_public_path__ + "0403320c05bbf02154f7762385a9b6b8.png";